import useUserHook from 'hooks/useUserHook';

import classes from 'components/widgets/myFocusHeader/myFocusHeader.module.scss';

export const MyFocusHeader = () => {
    const { firstName } = useUserHook();
    return (
        <div className={classes.container}>
            <div className={classes.content}>
                <strong>Hello {firstName},</strong>
                <br />
                Review upcoming activities assigned to you or tracked by you, your projects' status, and latest
                notifications.
            </div>
        </div>
    );
};
